module.exports = __webpack_public_path__ + "static/media/bloodPressure.7f6a0072.svg";